import { render, staticRenderFns } from "./ClassItem.vue?vue&type=template&id=348c1ef1&scoped=true&"
import script from "./ClassItem.vue?vue&type=script&lang=js&"
export * from "./ClassItem.vue?vue&type=script&lang=js&"
import style0 from "./ClassItem.vue?vue&type=style&index=0&id=348c1ef1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348c1ef1",
  null
  
)

export default component.exports